import { FaRegClock } from 'react-icons/fa';
import { useCustomTheme } from '../../hooks/useCustomTheme';

// Placeholder de recurso ainda não liberado para a empresa.
export default function EmBreve({
  titulo = 'Em breve',
  descricao = 'Este recurso ainda está em desenvolvimento e será liberado para a sua loja em breve.',
}) {
  const { theme } = useCustomTheme();

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        gap: 14,
        padding: '72px 24px',
        minHeight: 320,
      }}
    >
      <div
        style={{
          width: 72,
          height: 72,
          borderRadius: '50%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          color: theme.colors.primary,
          background: `${theme.colors.primary}14`,
        }}
      >
        <FaRegClock size={32} />
      </div>
      <h2 style={{ margin: 0, fontSize: 20, fontWeight: 700, color: theme.colors.text }}>
        {titulo}
      </h2>
      <p
        style={{
          margin: 0,
          maxWidth: 430,
          fontSize: 14,
          lineHeight: 1.55,
          color: theme.colors.textSecondary,
        }}
      >
        {descricao}
      </p>
    </div>
  );
}
